<template>

  <div>
    <v-container id="filter-sidebar" fluid class="slideRight" v-bind:style="{ left: left }">
        <div class="title">Columnas a mostrar:</div>
        <v-switch color="#9ddacf" v-for="header in list" v-model="header.visible" :disabled="header.blocked" @change="select(header)" :label=" getI18n( header.text ) "></v-switch>
    </v-container>
    <div @click="hide(this)" id="filter-overlay"></div>

  </div>

</template>

<script>
  import i18n from '@/i18n'
  export default {
    data () {
      return {
        show: false,
        list: {},
        callback: function() {},
        selected: [],
        left: '20%'
      }
    },
    methods: {
      select(column) {
        if(!column.visible) {
          this.selected.push(column.value);
        } else {
          var idx = this.selected.indexOf(column.value);
          if(idx != -1) {
            this.selected.splice(idx, 1);
          }
        }

        this.callback(this.selected);
      },
      hide (event) {
        this.$filter.close();
        this.show = false
        document.body.style.overflow = 'auto'
      },
      getI18n( label ){
          return i18n.t( label );
      },
    }
  }
</script>

<style lang="scss">
    #filter-overlay {
        background-color: #00000099;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 20;
    }

    #filter-sidebar {
      font-size: 14px;
      background-color: #fff;
      color: #111;
      position: fixed;
      left: 0;
      top: 168px;
      width: 350px;
      height: calc( 100% - 100px );
      overflow-y: auto;
      z-index: 21;
      padding: 20px 25px;
      padding-bottom: 0;

      .title {
        font-size: 16px;
        margin-bottom: 15px;
      }

      .v-input__slot {
        margin: 0;
      }

      .v-label {
        font-size: 14px;
      }

      .v-input {
        margin: 0;
        margin-bottom: -15px;
      }
    }


</style>
